export default "__VITE_ASSET__DIetud2U__"